var map = {
	"./cn.js": "43c6",
	"./en.js": "3fab",
	"./id.js": "fcd3",
	"./index.js": "9923",
	"./ja.js": "8c0c",
	"./kr.js": "4bcf",
	"./th.js": "46e9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c45d";